export default "__VITE_ASSET__m2YyLawT__"